<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Story in Event</h5>
            <div class="tabel-action tb-al mb-4 position-relative">
                <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                    <i class="uil uil-lock-alt"></i>
                </div>
                <button type="button" v-b-modal.modal-Story class="btn bg-white bdr-15 btn-block btn-lg"><i class="uil uil-plus mr-2"></i>Add Story</button>
            </div>
            
            <draggable
                v-bind="dragOptions" 
                v-model="storyGroup" 
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(data,index) in storyGroup" :key="data.id" class="link mb-3">
                        <div class="link-drag handle align-items-center d-flex">
                            <i class="uil uil-draggabledots"></i>
                        </div>
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-icon">
                                    <div class="no-img" v-if="!data.photo"><span class="w-100">NO IMAGE</span></div>
                                    <img v-if="data.photo" width="80px" :src="data.photo">
                                </div>
                                <div class="link-item pr-5">
                                    <div><strong>{{data.title}}</strong></div>
                                </div>
                                <div class="link-switch">
                                    <a href="#" v-b-modal.modal-Story v-on:click.prevent="ASSIGN_FORM_STORY(data)" class="act">
                                        <i class="uil uil-pen"></i>
                                        <span class="link-tx"> Edit</span>
                                    </a>
                                    <a href="#" v-on:click.prevent="alertDelete(data.id,index)" class="act">
                                        <i class="uil uil-trash-alt"></i>
                                        <span class="link-tx"> Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </transition-group>

            </draggable>
        </div>

        <b-modal id="modal-Story" size="lg" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_STORY">

            <ValidationObserver ref="form">
                <div class="row">
                    <div class="col-md-12">
                        <validation-provider v-if="!formstory.photo" rules="required|mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                            <div class="form-group">
                                <div class="mb-1">
                                    <label>Story Photo</label>
                                </div>
                                <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                    <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                </div>
                                <input ref="inputImage" 
                                        type="file"
                                        class="custom-file-input d-none"
                                        id="Thumbnail"
                                        v-on:change="onImageUpload"
                                        accept="image/jpeg,image/png,image/jpg" 
                                        @input="validate" >
            
                                <div class="invalid-input mt-3">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                        
                        <div class="form-group" v-if="formstory.photo">   
                            <div class="mb-1">
                                <label>Story Photo</label>
                            </div> 
                            <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                            <div class="input-group img-sh">
                                <img :src="formstory.photo" class="img-responsive img-prf">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Story Title</label>
                                <input v-model="formstory.title" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Story Description</label>
                            <textarea v-model="formstory.desc" class="form-control"></textarea>
                        </div>
                    </div>
                </div>
              
                <div class="text-right">
                    <button v-on:click="validationForm(formstory.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Story
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import draggable from 'vuedraggable'

    export default{
        data(){
            return{
                drag: false,
                loading:false,
                modal_title : 'Add Story',
                photo_file:'',
            }
        },
        watch:{
            'formstory':function(val){
                if(val.id){
                    this.modal_title = 'Edit Story'
                }else if(!val.id){
                    this.modal_title = "Add Story"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        computed:{
            ...mapState('EventsControl', {
                detail_event: state => state.detail_event,
                formstory: state => state.formstory
            }),

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            storyGroup: {
                get() {
                    return this.detail_event.story
                },
                set(value) {
                    this.SET_POSITION_STORY(value)
                    this.updatePositionStory(value)
                }
            }
        },
        methods:{
            ...mapMutations('EventsControl', ['SET_POSITION_STORY','CLEAR_FORM_STORY','ASSIGN_FORM_STORY']),
            ...mapActions('EventsControl', ['detailEvents','createStory','updateStory','deleteStory','updatePositionStory']),
            
            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formstory.photo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.photo_file = input.files[0]
            },
            removeImageUpload:function(){
                this.photo_file = ''
                this.formstory.photo = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('title', this.formstory.title);
                        formData.append('desc', this.formstory.desc);
                        formData.append('photo_file', this.photo_file);
                        formData.append('photo', this.formstory.photo ? this.formstory.photo : '');
                        
                        if(id){
                            formData.append("_method", "put");

                            this.updateStory(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Story')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_STORY()
                                this.photo_file = ''
                                this.$toast.success('Successfully Update Story')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createStory(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Story')
                                this.detailEvents(this.$route.params.id)
                                this.photo_file = ''
                                this.CLEAR_FORM_STORY()
                                this.$toast.success('Successfully Added Story')
                            }).catch((error) => {
                                this.loading = false
                                if(error.response.data.errors == 'package'){
                                    this.$toast.warning('Sorry, Upgrade your package to use this feature')
                                }else{
                                    this.$toast.warning('Sorry, Something Error')
                                }
                            }) 
                        }
                    }
                });
            },
            alertDelete:function(id,index){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this story data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteStory(id).then(
                            this.$toast.success('Successfully Deleting Story'),
                            this.detail_event.story.splice(index, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },
        }
    }

</script>

<style scoped>
    .img-sh img{
        width: 300px;
    }
    .link-icon img,
    .link-icon .no-img{
        width: 60px;
        height: 60px;
    }
    
</style>